<template>
  <div class="pop-up">
    <LoadingPopup v-if="!see" />
  </div>
  <div class="background" ref="foo" v-if="see">
    <div class="header-container">
      <!-- Header -->
      <h2 class="header">
        {{ $t("results.results") }}
      </h2>

      <h2 class="header">
        {{ $store.state.answers.lastChangeDate }}
      </h2>
    </div>

    <div class="result-diagram-container center-div" v-if="see">
      <div class="result-diagram">
        <!-- Radar chart -->
        <Radar id="my-chart-id" :options="chartOptions" :data="chartData" />
      </div>

      <div class="range-desc">
        <h5>{{ $t('results.initial_range') }}</h5>
        <div>{{ $t('results.initiated_description') }}</div>

        <h5>{{ $t('results.defined_range') }}</h5>
        <div>{{ $t('results.defined_description') }}</div>

        <h5>{{ $t('results.basic_range') }}</h5>
        <div>{{ $t('results.basic_description') }}</div>

        <h5>{{ $t('results.standard_range') }}</h5>
        <div>{{ $t('results.standard_description') }}</div>
      </div>

      <!-- Panel -->
      <div class="panel">
        <div class="panel-options">
          <svg @click="printDownload" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
            <path
              d="M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z" />
          </svg>
          <div @click="printDownload" class="download-label">{{ $t("results.PDF") }}</div>
        </div>
        <div class="panel-options">
          <svg @click="downloadData(true)" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
            class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
            <path
              d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
            <path
              d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
          </svg>

          <div @click="downloadData(true)" class="download-label">{{ $t("results.save_local") }}</div>
        </div>
        <div class="panel-options">
          <svg @click="downloadData(false)" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
            class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
            <path
              d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
            <path
              d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
          </svg>
          <div @click="downloadData(false)" class="download-label">{{ $t("results.save_summary_local") }}</div>
        </div>
      </div>
    </div>

    <div class="info-container" v-if="this.$store.state.benchmark.length === 0">
      {{ $t('results.more') }}

      <div>
        <router-link :to="{ name: 'sendResults' }">
          <button class="btn btn-outline-dark next">
            {{ $t("results.send_data") }}
          </button>
        </router-link>
      </div>
    </div>

    <!-- Benchmark graph -->
    <div v-if="completeView">
      <div>
        <h2 class="header"> {{ $t('results.benchmark_results') }} </h2>
      </div>
      <div class="center-div">
        <div>
          <Line :data="benchmarkData" :options="chartOptionsLine" width="1300" height="250" />
        </div>
      </div>
    </div>

    <!-- Dimension descriptions -->
    <div class="description-container-header">
      <div style="display: flex; gap: 10px">
        <h2 class="header">{{ $t('results.process_dim') }}</h2>
      </div>
      <div style="display: flex; gap: 10px">
        <h2 class="header">{{ $t('results.system_dim') }}</h2>
      </div>
    </div>
    <div class="description-container">
      <div v-for="i in descriptionOrder" style="display: flex; gap: 10px">
        <h5>{{ categories[i].category }}</h5>
        {{ categories[i].categoryDescription[$i18n.locale] }}
      </div>

    </div>


    <div>
      <h2 class="header">
        {{ $t("results.maturity_levels") }}
      </h2>
      <div style="display: flex;">
        <div style="max-width:1800px;">
          <Line :data="levelsChart" :options="chartOptionsLine" width="800" height="200" />
        </div>

        <div class="level-desc">
          <h5 style="color:#0066ff;" class="line-symbol">— </h5>
          <h5>{{ $t('results.initiated') }}</h5>
          <div>{{ $t('results.initiated_description2') }}</div>

          <h5 style="color:#301934;" class="line-symbol">— </h5>
          <h5>{{ $t('results.basic').toUpperCase() }}</h5>
          <div>{{ $t('results.basic_description2') }}</div>

          <h5 style="color:#ffb55a;" class="line-symbol">— </h5>
          <h5>{{ $t('results.defined').toUpperCase() }}</h5>
          <div>{{ $t('results.defined_description2') }}</div>

          <h5 style="color:#b2e061;" class="line-symbol">— </h5>
          <h5>{{ $t('results.standard').toUpperCase() }}</h5>
          <div>{{ $t('results.standard_description2') }}</div>
        </div>


      </div>
    </div>

    <div class="footer" v-if="!completeView">
      <div class="navigation-buttons">
        <router-link :to="{ name: 'sendResults' }">
          <button class="btn btn-outline-dark back">
            {{ $t("back") }}
          </button>
        </router-link>
      </div>

      <div class="navigation-buttons">
        <router-link :to="{ name: 'sendResults' }">
          <button class="btn btn-outline-dark next">
            {{ $t("results.send_data") }}
          </button>
        </router-link>
      </div>
    </div>

  </div>
</template>
<script>
import { Radar, Line } from 'vue-chartjs'
import * as  chartConfig from './chartConfig.js'
import LoadingPopup from "../Popups/LoadingPopup";

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  LinearScale,
  CategoryScale,
} from 'chart.js'


ChartJS.register(
  RadialLinearScale, Tooltip, Legend, PointElement, LineElement, Filler, LinearScale, CategoryScale)

export default {
  name: 'SummaryView',
  components: { Radar, Line, LoadingPopup },
  data() {
    return {
      chartData: JSON.parse(JSON.stringify(chartConfig.chartData)),
      chartOptions: JSON.parse(JSON.stringify(chartConfig.chartOptions)),
      benchmarkData: JSON.parse(JSON.stringify(chartConfig.benchmarkChart)),
      see: false,
      categories: this.$store.state.metadata.questionnaire,
      completeView: false,
      recommendation: JSON.parse(JSON.stringify(chartConfig.recommended)),
      descriptionOrder: [0, 5, 1, 6, 2, 7, 3, 8, 4, 9],
      levelsChart: JSON.parse(JSON.stringify(chartConfig.levelsChart)),
      chartOptionsLine: JSON.parse(JSON.stringify(chartConfig.chartOptionsLine))
    }
  },
  /* watch: {
     '$i18n.locale': {
       deep: true,
       handler() {
         this.see=false
         this.chartData.datasets[0].label = this.$t('results.results')
         this.chartData.datasets[1].label = this.$t('results.goal')
         console.log("LANG change", this.$i18n.locale)
         this.see=true
       }
     }
   },*/
  methods: {

    printDownload() {
      window.print()
    },

   // Quick fix for data sequence change
    changeSequence(array) {
      var list = []

      var newSequence = [0,9,8,7,6,1,2,3,4,5]

      for (let i = 0; i < newSequence.length; i++) {
        list.push(array[newSequence[i]])
      }

      return list
    },

    calculateSummary() {
      this.levelsChart.datasets[0].data = this.changeSequence(this.$store.state.calculatedSummaryData["initial"])
      this.levelsChart.datasets[1].data = this.changeSequence(this.$store.state.calculatedSummaryData["defined"])
      this.levelsChart.datasets[2].data = this.changeSequence(this.$store.state.calculatedSummaryData["basic"])
      this.levelsChart.datasets[3].data = this.changeSequence(this.$store.state.calculatedSummaryData["standard"])
      this.chartData.datasets[0].data = this.$store.state.calculatedSummaryData["result"]
      this.benchmarkData.datasets[0].data = this.changeSequence(this.$store.state.calculatedSummaryData["result"])

      this.levelsChart.datasets[0].label = this.$t('results.initial')
      this.levelsChart.datasets[1].label = this.$t('results.defined')
      this.levelsChart.datasets[2].label = this.$t('results.basic')
      this.levelsChart.datasets[3].label = this.$t('results.standard')
      this.chartData.datasets[0].label = this.$t('results.results')
      this.benchmarkData.datasets[0].label = this.$t('results.results')
    },

    downloadData(detailed) {
      if (detailed) {
        const currentdate = new Date();
        const datetime = "MASS_detailed_answers_" + currentdate.getDate() + "_"
          + (currentdate.getMonth() + 1) + "_"
          + currentdate.getFullYear() + '.txt';
        const fileURL = window.URL.createObjectURL(new Blob([JSON.stringify(this.$store.state.answers)]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', datetime);
        document.body.appendChild(fileLink);

        fileLink.click();
      } else {
        const currentdate = new Date();
        const datetime = "MASS_summary_" + currentdate.getDate() + "_"
          + (currentdate.getMonth() + 1) + "_"
          + currentdate.getFullYear() + '.txt';

        this.$store.state.calculatedSummaryData["lastChangeDate"] = this.$store.state.answers.lastChangeDate;
        const fileURL = window.URL.createObjectURL(new Blob([JSON.stringify(this.$store.state.calculatedSummaryData)]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', datetime);
        document.body.appendChild(fileLink);

        fileLink.click();
      }
    },
    dynamicColors() {
      const r = Math.floor(Math.random() * 255);
      const g = Math.floor(Math.random() * 255);
      const b = Math.floor(Math.random() * 255);
      return "rgb(" + r + "," + g + "," + b + ")";
    }

  },
  mounted() {
    this.calculateSummary();
    this.chartData.datasets.push(this.recommendation)
    this.chartData.datasets[1].label = this.$t('results.goal')

    if (this.$store.state.benchmark.length > 0) {
      this.$store.state.benchmark.forEach(b => {
        let color = this.dynamicColors();
        b["borderColor"] = color;
        b["pointBackgroundColor"] = color;
        this.benchmarkData.datasets.push(b);
      })
      this.completeView = true;
    }

    this.see = true;
  },
}
</script>
<style scoped lang="scss">
.info-container {
  align-content: center;
  padding: 3rem 5rem 0rem;
  font-weight: bold;
  font-size: 1.2rem;
}

.result-diagram {
  min-width: 500px;
  //margin-left: 120px;
  padding-left: 1rem;
}

.background {
  background-color: #ffffff;
  width: 90%;
  padding: 1rem;
  margin-left: 100px;
  min-width: 1327px;
}

.header {
  font-size: 2rem;
  padding-left: 1rem;
  text-align: left;
}


.header-container {
  display: flex;
  gap: 10px;
  height: 40px;
  padding-bottom: 90px;
}

.result-diagram-container {
  display: flex;
  gap: 4rem;
  align-items: center;
  padding-bottom: 4rem;

}

.footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding-top: 5rem
}


.pop-up {
  position: absolute;
  top: 20%;
  left: 35%;
}

.description-container {
  display: grid;
  grid-template-columns: auto auto;
  text-align: left;
  column-gap: 50px;
  row-gap: 20px;
  padding: 1rem 1rem 3rem 1rem;
  font-size: 0.9rem;
}

.description-container-header {
  display: grid;
  grid-template-columns: auto auto;
  text-align: left;
  column-gap: 50px;
  row-gap: 20px;
  padding: 3rem 0 0 0;
  font-size: 0.9rem;
}

.download-label {
  text-align: left;
  cursor: pointer;
}

.level-desc {
  display: grid;
  grid-template-columns: auto auto auto;
  text-align: left;
  column-gap: 20px;
  font-size: 0.9rem;
  //padding-top: 5rem;
}

.range-desc {
  width: 700px;
  display: grid;
  grid-template-columns: 200px auto;
  text-align: left;
  font-size: 0.9rem;
  min-height: 400px;
}

.line-symbol {
  margin-top: -10px;
  font-size: 2rem;
}

.center-div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel {
  background-color: rgba(170, 216, 231, 0.849);
  padding: 2rem;
  //height: 200px;
  margin-top: -200px;
}

.panel-options {
  display: grid;
  grid-template-columns: 10px auto;
  gap: 2rem;
  padding: 0.5rem;
}
</style>
